module.exports = __webpack_public_path__ + "static/flags/CD-1891b4d359cc2bd35f1f7abe0cc47acb.gif";